export default {
    pathActive: {
        color: '#00B3C5',
    },
    pathNotActive: {
        color: '#FCD634',
    },
}
